import { theme as theme$1 } from '@chakra-ui/pro-theme';
import { extendTheme } from './node_modules/@chakra-ui/theme-utils/dist/chunk-AQYX3YP4.mjs';
import { components } from './components/index.mjs';
import * as index from './foundations/index.mjs';
import { styles } from './styles.mjs';
import typography from './foundations/typography.mjs';
import colors from './foundations/colors.mjs';

const theme = extendTheme(theme$1, {
  styles,
  ...index,
  ...typography,
  colors: { ...colors, brand: colors["gray"] },
  components: {
    ...components
  }
});

export { theme };
